var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.packages.length)?_c('ul',_vm._l((_vm.packages),function(packageItem){return _c('li',[_c('a',{attrs:{"href":packageItem._links.frontend[_vm.linkKey]}},[_c('strong',[_vm._v(_vm._s(packageItem.project)+": ")]),_vm._v(_vm._s(packageItem.name)+" "),_c('i',[_vm._v("("+_vm._s(packageItem.reference)+")")])])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }